import { requestJSON } from '../../../NonReact/common/API/REST/RESTClient'
import { getByUsernameURL, sendEmailURL } from '../../../NonReact/constants/ApiConstants'
import { RESTMethods } from '../../../NonReact/constants/REST'
import { JSONResponse } from '../../../NonReact/common/Types/Types'

export enum EmailType {
    WELCOME = 'SendWelcomeEmail',
    AUTH_EMAIL = 'SendAuthEmail'
}

/**
 * Send an email to the user.
 *
 * @param userName - The username.
 * @param emailType - The email type to send.
 *
 * @returns - The JSON response.
 */
export const sendEmailForUser = (userName: string, emailType: EmailType): Promise<JSONResponse<void>> =>
    requestJSON(sendEmailURL(userName), {
        method: RESTMethods.PUT,
        body: {
            [emailType]: true
        }
    })

/**
 * Sends a welcome email to the user: generates a new random password, triggers
 * the welcome email send, and persists {@code NotifyPasswordChgs=true} so the
 * checkbox state is accurate on next page load.
 *
 * @param userName - The username to send the welcome email to.
 * @returns Promise resolving when the request completes.
 */
export const sendWelcomeEmailForUser = (userName: string): Promise<JSONResponse<void>> =>
    requestJSON(sendEmailURL(userName), {
        method: RESTMethods.PUT,
        body: {
            [EmailType.WELCOME]: true,
            NotifyPasswordChgs: true
        }
    })

/**
 * Updates the {@code NotifyPasswordChgs} flag for the given user without
 * triggering a password change or email send.
 *
 * @param userName - The username to update.
 * @param value - The new value for {@code NotifyPasswordChgs}.
 * @returns Promise resolving when the request completes.
 */
export const updateUserNotifyPasswordChange = (userName: string, value: boolean): Promise<JSONResponse<void>> =>
    requestJSON(getByUsernameURL(userName), {
        method: RESTMethods.PUT,
        body: { NotifyPasswordChgs: value }
    })
